import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { useTranslation } from 'react-i18next'
import calculateDaysUntilDate from './calculateDaysUntilDate'
import FormationForm from './FormationForm/FormationForm'
import useSpeedFormation from './useSpeedFormation'

const SpeedFormation = () => {
  const { t } = useTranslation()
  const { speedFormation, isAdmin, isEditing, setIsEditing, hasDueDate } = useSpeedFormation()

  return (
    <>
      {isEditing && <FormationForm />}
      {!isEditing && (
        <div>
          {speedFormation ? (
            <>
              <div dangerouslySetInnerHTML={{ __html: speedFormation.text }} />
              <div hidden={!hasDueDate}>{calculateDaysUntilDate(speedFormation.date, t)}</div>
            </>
          ) : (
            <p>{t('home:speed_formation.not_created_yet')}</p>
          )}
        </div>
      )}
      {!isEditing && isAdmin && (
        <SDButton id='speed-formation-edit-button' onClick={() => setIsEditing(true)}>
          {t('common:edit')}
        </SDButton>
      )}
    </>
  )
}

export default SpeedFormation
